<template>
  <ValidationObserver ref="obs" v-slot="{ invalid, validated, validate }">
    <v-card color="transparent" :elevation="0">
      <v-card-title>
        <span v-if="step == 1" class="title font-weight-regular">{{
          $Amplify.I18n.get("Ingrese el RUC de su organización")
        }}</span>
        <v-slide-x-transition>
          <span v-if="step == 2" class="title font-weight-regular">{{
            $Amplify.I18n.get("Verifique sus datos")
          }}</span>
        </v-slide-x-transition>
      </v-card-title>

      <v-card-text>
        <v-alert
          v-if="alert.message"
          v-model="alert.show"
          prominent
          dense
          dismissible
          :type="alert.type || 'error'"
          transition="scale-transition"
        >
          <v-layout align-center wrap>
            <div>
              {{ alert.message }}
            </div>
          </v-layout>
        </v-alert>
      </v-card-text>
      <v-card-text>
      
        <ValidationProvider
          name="ruc"
          ref="myinput"
          rules="required|min:13"
          v-slot="{ errors, valid }"
        >
          <v-text-field
            v-model="payload.empresa.ruc"
            autofocus
            label="Ruc"
            placeholder="Ingrese el RUC"
            :error-messages="errors"
            :success="valid"
            outlined
          >
            <template v-slot:append>
              <v-slide-x-transition>
                <v-icon color="success" v-if="valid">
                  mdi-check-circle
                </v-icon>
              </v-slide-x-transition>
            </template>
          </v-text-field>
        </ValidationProvider>
        <v-slide-y-transition>
          <v-container ma-0 pa-0>
            <ValidationProvider
              name="razon social"
              rules="required"
              v-slot="{ errors, valid }"
            >
              <v-text-field
                v-model="payload.empresa.razon_social"
                autofocus
                label="Razón Social"
                placeholder="Ingrese la razón social"
                :error-messages="errors"
                :success="valid"
                outlined
              >
              </v-text-field>

            </ValidationProvider>
          </v-container>
        </v-slide-y-transition>
      </v-card-text>

      <v-card-actions>
        <span>
          <a v-on:click="back">{{ $Amplify.I18n.get("Back") }}</a>
        </span>
        <v-spacer></v-spacer>


        <v-btn
          v-on:click="createAccount()"
          color="primary"
          class="px-4"
          :disabled="invalid || !validated || loadingBtn"
          :loading="loadingBtn"
        >
          {{ $Amplify.I18n.get("Finalize") }}
          <template v-slot:loader>
            <v-progress-circular
              :size="18"
              :width="2"
              indeterminate
              class="mr-1"
            ></v-progress-circular>
            <span>{{ $Amplify.I18n.get("Wait...") }}</span>
          </template>
        </v-btn>
      </v-card-actions>
    </v-card>
  </ValidationObserver>
</template>

<script>
import Amplify from "aws-amplify";
import { AmplifyEventBus } from "aws-amplify-vue";
import { postCuenta } from "@/api/private/cuentas";

import {
  Validator,
  ValidationObserver,
  ValidationProvider
} from "vee-validate";

Validator.extend("rucEcuador", {
  getMessage: () => Amplify.I18n.get("ruc is not valid"),
  validate: value => {
    if (typeof value == "string" && value.length == 13 && /^\d+$/.test(value)) {
      var digitos = value.split("").map(Number);
      var codigo_provincia = digitos[0] * 10 + digitos[1];
      var tipo_modulo;
      var coeficientes;
      if (
        (codigo_provincia >= 1 && codigo_provincia <= 24) ||
        codigo_provincia == 30
      ) {
        if (digitos[2] != 7 || digitos[2] != 8) {
          tipo_modulo = digitos[2] > 5 ? 11 : 10;
          if (digitos[2] == 6) {
            digitos = digitos.slice(0, 9);
            coeficientes = [3, 2, 7, 6, 5, 4, 3, 2];
          } else {
            digitos = digitos.slice(0, 10);
            coeficientes =
              digitos[2] == 9
                ? [4, 3, 2, 7, 6, 5, 4, 3, 2]
                : [2, 1, 2, 1, 2, 1, 2, 1, 2];
          }
          var digito_verificador = digitos.pop();
          var digito_calculado =
            tipo_modulo -
            (digitos.reduce(function(valorPrevio, valorActual, indice) {
              var resultado = valorActual * coeficientes[indice];
              if (digitos[2] < 6) {
                resultado = resultado > 9 ? resultado - 9 : resultado;
              }
              return valorPrevio + resultado;
            }, 0) %
              tipo_modulo);
          digito_calculado = digito_calculado === 11 ? 0 : digito_calculado;

          if (digito_calculado === digito_verificador) {
            ///var sum = 0;
            digitos.map(function(digito, indice) {
              ///var posicion = indice + 1;
              var buff = 0;
              buff = digito * coeficientes[indice];
              if (digitos[2] < 6 && buff > 9) {
                buff -= 9;
              }
              ///sum += buff;
            });
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
    //return false;
  }
});
export default {
  name: "RegistrarEntidad",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    codigoPais: {
      type: String,
      default: "ec"
    }
  },
  data() {
    return {
      loadingBtn: false,
      payload: {
        empresa: {
          ruc: null,
          razon_social: null
        },
        cpcs: []
      },
      step: 1,
      alert: {
        show: false,
        type: "",
        message: ""
      },
      error: "",
      logger: {}
    };
  },
  methods: {
    createAccount: async function() {
      this.setAlert({});
      this.loadingBtn = true;
      try {
        console.log('this.$store.getters.tipoCliente', this.$store.getters.tipoCliente);
        Object.assign(this.payload.empresa, { codigoPais: this.codigoPais, tipoCliente: this.$store.getters.tipoCliente });
        this.payload.cpcs = [];
        this.payload.usuario = this.$store.getters.user.attributes;
        await postCuenta(this.payload);
        this.$router.push("/preloader");
      } catch (err) {
        if (err.response.status == 504) {
          this.createAccount();
        } else {
          this.setError(err);
        }
      } finally {
        this.loadingBtn = false;
      }
    },
    back() {
      AmplifyEventBus.$emit("back-to-select-country");
    },
    setError(e) {
      this.error = this.$Amplify.I18n.get(
        e.response.data.message || e.message || e
      );
      this.setAlert({ message: this.error });
      this.logger.error(this.error);
    },
    setAlert: function({ message = "", type = "error" }) {
      this.alert = {
        message,
        type,
        show: message.length > 1 ? true : false
      };
    }
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  }
};
</script>
